import { Cascader, Form } from "antd";
import last from "lodash/last";
import map from "lodash/map";
import get from "lodash/get";

const DeviceCascaderSelector = (props) => {
  const {
    name,
    data,
    edit,
    onChange,
    enableChangeOnSelect,
    noInputHeading,
    setRules,
    placeHolderText,
    displayOnlyChild,
    required,
  } = props;
  // console.log("setRules", setRules);
  const displayRender = (labels, selectedOptions) =>
    map(labels, (label, i) => {
      const option = selectedOptions[i];
      if (i === labels.length - 1) {
        return (
          <span key={get(option, "value", "")} className="text-overflow">
            {label}
          </span>
        );
      }
      return !displayOnlyChild ? (
        <span key={get(option, "value", "")}>{label} / </span>
      ) : (
        <></>
      );
    });

  const validateParent = (rule, value, callback) => {
    if (!value || edit) {
      callback();
      return;
    }

    const deviceArr = last(value).split("@");

    if (deviceArr[0] === "DEVICE") {
      callback();
      return;
    }

    callback("Please Select Device");
  };

  return (
    <Form.Item
      name={name ? name : "deviceId"}
      label={noInputHeading ? null : "Device"}
      rules={
        setRules
          ? []
          : [
              required
                ? {
                    required: true,
                    message: "Please Select Device",
                  }
                : undefined,
              {
                validator: validateParent,
              },
            ]
      }
    >
      <Cascader
        className="cascader-space"
        displayRender={displayRender}
        allowClear={false}
        onChange={(value) => {
          onChange(value);
        }}
        disabled={edit}
        options={data}
        size="small"
        changeOnSelect={enableChangeOnSelect}
        placeholder={placeHolderText || "Please select"}
      />
    </Form.Item>
  );
};

export default DeviceCascaderSelector;
